var map = {
	"./default/banner__fixed-extension.png": 61396,
	"./default/banner__upgrade-bg.png": 64688,
	"./default/bg__brand-h5.png": 64379,
	"./default/bg__brand.png": 40974,
	"./default/bg__fixed-extension-title.png": 81202,
	"./default/bg__huiyi.png": 84711,
	"./default/bg__new-user-discount-bottom-v1.png": 27305,
	"./default/bg__new-user-discount-v1.png": 46023,
	"./default/bg__pdf.png": 2413,
	"./default/btn__arrow.png": 66799,
	"./default/card-close.png": 70968,
	"./default/card-logo.png": 23657,
	"./default/card-setting.png": 55021,
	"./default/card-sound.png": 48438,
	"./default/card-voice.gif": 99675,
	"./default/clear_number.png": 37458,
	"./default/clear_number_hover.png": 32768,
	"./default/common/icon__btn-arrow.png": 40669,
	"./default/common/icon__copy.svg": 47415,
	"./default/common/icon__download.svg": 52657,
	"./default/common/icon__upload.svg": 94035,
	"./default/common/num__1.png": 44776,
	"./default/common/num__2.png": 23346,
	"./default/common/num__3.png": 95902,
	"./default/download_icon.png": 14080,
	"./default/download_save.png": 56340,
	"./default/educationIncentives/50-off.png": 14066,
	"./default/educationIncentives/bell-icon.png": 53632,
	"./default/educationIncentives/bell-star.png": 49889,
	"./default/educationIncentives/bg-line.png": 32710,
	"./default/educationIncentives/big-line.png": 24581,
	"./default/educationIncentives/docs-img.png": 55049,
	"./default/educationIncentives/fireworks.png": 49272,
	"./default/educationIncentives/qr-code-bg-icon.png": 83285,
	"./default/educationIncentives/qr-code-bg.png": 48379,
	"./default/educationIncentives/qr-code.png": 72126,
	"./default/educationIncentives/red-star.png": 21295,
	"./default/educationIncentives/short-line.png": 31941,
	"./default/educationIncentives/submit-icon.png": 66437,
	"./default/educationIncentives/title-bg.png": 90472,
	"./default/educationIncentives/world_school_name_list": 32617,
	"./default/educationIncentives/world_school_name_list.json": 32617,
	"./default/educationIncentives/yellow-star-45.png": 75120,
	"./default/educationIncentives/yellow-star.png": 30776,
	"./default/home-page-v1/action__ctrl-hover.png": 58007,
	"./default/home-page-v1/banner__edu.png": 89847,
	"./default/home-page-v1/banner__invite.png": 56976,
	"./default/home-page-v1/banner__learning.png": 93678,
	"./default/home-page-v1/bg__banner.png": 1083,
	"./default/home-page-v1/bg__browser-active.png": 76365,
	"./default/home-page-v1/bg__browser-hover.png": 86725,
	"./default/home-page-v1/bg__comment.png": 22976,
	"./default/home-page-v1/bg__guide-1.png": 23772,
	"./default/home-page-v1/bg__guide-2.png": 86327,
	"./default/home-page-v1/bg__install-video-v1.png": 56653,
	"./default/home-page-v1/bg__install-video.png": 88961,
	"./default/home-page-v1/bg__online.png": 14594,
	"./default/home-page-v1/bg__slogan.png": 41606,
	"./default/home-page-v1/bg__title-comment.png": 86021,
	"./default/home-page-v1/bg__title-guide.png": 47218,
	"./default/home-page-v1/bg__top-bg-invite.png": 78160,
	"./default/home-page-v1/bg__top-bg-learning.png": 12270,
	"./default/home-page-v1/bg__top-bg1.png": 25999,
	"./default/home-page-v1/bg__top-bg2.png": 54619,
	"./default/home-page-v1/bg__video-box.png": 96624,
	"./default/home-page-v1/bg__video-hover.png": 94934,
	"./default/home-page-v1/bg__video-pdf.png": 1695,
	"./default/home-page-v1/bg__video-web.png": 13329,
	"./default/home-page-v1/figure.gif": 14634,
	"./default/home-page-v1/icon__close-video-modal-hover.png": 21519,
	"./default/home-page-v1/icon__close-video-modal.png": 15278,
	"./default/home-page-v1/icon__download.png": 83286,
	"./default/home-page-v1/icon__figure-right.png": 64014,
	"./default/home-page-v1/icon__figure-top.png": 86896,
	"./default/home-page-v1/icon__hover.png": 54752,
	"./default/home-page-v1/icon__learning.png": 73352,
	"./default/home-page-v1/icon__online.png": 62972,
	"./default/home-page-v1/icon__pdf.png": 88419,
	"./default/home-page-v1/icon__play.png": 15172,
	"./default/home-page-v1/icon__star.png": 34956,
	"./default/home-page-v1/icon__web.png": 56831,
	"./default/home-page-v1/img__arrow-right.png": 45144,
	"./default/home-page-v1/tips__ctrl-action.png": 2219,
	"./default/home-page-v1/tips__web-click.png": 83242,
	"./default/home-page-v1/yi.png": 14745,
	"./default/icon__add.png": 42121,
	"./default/icon__arrow-right-gray-hover.png": 58914,
	"./default/icon__arrow-right-gray.png": 83722,
	"./default/icon__arrow_down.png": 88745,
	"./default/icon__arrow_up.png": 5899,
	"./default/icon__bell.png": 84099,
	"./default/icon__card-delete.png": 84997,
	"./default/icon__card-link.png": 74789,
	"./default/icon__card-video.png": 79594,
	"./default/icon__celebrate.png": 39301,
	"./default/icon__checkbox-checked.png": 23170,
	"./default/icon__checkbox-hover.png": 47144,
	"./default/icon__checkbox.png": 92017,
	"./default/icon__close-with-border-hover.png": 5039,
	"./default/icon__close-with-border-v1.png": 92786,
	"./default/icon__close-with-border.png": 70089,
	"./default/icon__close.png": 15315,
	"./default/icon__default-avatar.png": 3225,
	"./default/icon__default-favicon.png": 35585,
	"./default/icon__delete-hover.png": 98019,
	"./default/icon__delete.png": 92450,
	"./default/icon__edit-hover.png": 65428,
	"./default/icon__edit.png": 4851,
	"./default/icon__empty.png": 71722,
	"./default/icon__favorite-empty.png": 27099,
	"./default/icon__key.png": 76407,
	"./default/icon__lang-empty.png": 19866,
	"./default/icon__lingdang.png": 79254,
	"./default/icon__logo.png": 4717,
	"./default/icon__model.png": 30695,
	"./default/icon__original-hover.png": 91796,
	"./default/icon__original.png": 4067,
	"./default/icon__parallel-hover.png": 99249,
	"./default/icon__parallel.png": 30472,
	"./default/icon__pointer.png": 18146,
	"./default/icon__question.png": 36759,
	"./default/icon__radio-checked.png": 22182,
	"./default/icon__radio-hover.png": 53655,
	"./default/icon__radio.png": 25175,
	"./default/icon__right-arrow.png": 77901,
	"./default/icon__settings-hover.png": 25363,
	"./default/icon__settings-v1.png": 68756,
	"./default/icon__settings.png": 21596,
	"./default/icon__source-lang.png": 95789,
	"./default/icon__star-yellow.png": 72187,
	"./default/icon__star.png": 43513,
	"./default/icon__stick.png": 64733,
	"./default/icon__switch-v1.png": 58562,
	"./default/icon__switch.png": 53228,
	"./default/icon__tab-favorite-empty.png": 67035,
	"./default/icon__tab-favorite.png": 35316,
	"./default/icon__tab-pdf-empty.png": 41656,
	"./default/icon__tab-pdf.png": 47679,
	"./default/icon__target-lang.png": 75085,
	"./default/icon__top-img-v1.png": 57782,
	"./default/icon__translation-hover.png": 96207,
	"./default/icon__translation.png": 86883,
	"./default/icon__vip-free.png": 80402,
	"./default/icon__vip-vip1.png": 67544,
	"./default/icon__yi.png": 78008,
	"./default/image-translate/icon__image.svg": 57319,
	"./default/image-translate/icon__reload.svg": 24444,
	"./default/image-translate/icon__upload-img.svg": 35906,
	"./default/install-arrow-top-icon.png": 85056,
	"./default/install-bell-icon.png": 75966,
	"./default/install-store-icon.png": 4807,
	"./default/learning/empty__grasp.png": 38040,
	"./default/learning/empty__unlearned.png": 56349,
	"./default/learning/icon__add-grasp-v1.png": 92564,
	"./default/learning/icon__add-unlearned-v1.png": 87777,
	"./default/learning/icon__arrow.png": 57503,
	"./default/learning/icon__back.png": 90966,
	"./default/learning/icon__delete.png": 66033,
	"./default/learning/icon__in-grasp.png": 19412,
	"./default/learning/icon__in-unlearned.png": 61957,
	"./default/learning/icon__pro-lock.png": 82743,
	"./default/learning/icon__pro-v-lock.png": 7276,
	"./default/learning/icon__qingzhu.png": 88977,
	"./default/learning/icon__star-warning.png": 85720,
	"./default/learning/icon__star.png": 63285,
	"./default/learning/like.png": 92081,
	"./default/learning/path__empty-line.png": 15715,
	"./default/learning/path__line-1.png": 76,
	"./default/learning/path__line.png": 18084,
	"./default/libs/cmaps/78-EUC-H.bcmap": 11095,
	"./default/libs/cmaps/78-EUC-V.bcmap": 95359,
	"./default/libs/cmaps/78-H.bcmap": 72902,
	"./default/libs/cmaps/78-RKSJ-H.bcmap": 61202,
	"./default/libs/cmaps/78-RKSJ-V.bcmap": 60221,
	"./default/libs/cmaps/78-V.bcmap": 52302,
	"./default/libs/cmaps/78ms-RKSJ-H.bcmap": 4295,
	"./default/libs/cmaps/78ms-RKSJ-V.bcmap": 41540,
	"./default/libs/cmaps/83pv-RKSJ-H.bcmap": 51674,
	"./default/libs/cmaps/90ms-RKSJ-H.bcmap": 44224,
	"./default/libs/cmaps/90ms-RKSJ-V.bcmap": 26976,
	"./default/libs/cmaps/90msp-RKSJ-H.bcmap": 70775,
	"./default/libs/cmaps/90msp-RKSJ-V.bcmap": 3538,
	"./default/libs/cmaps/90pv-RKSJ-H.bcmap": 40861,
	"./default/libs/cmaps/90pv-RKSJ-V.bcmap": 40786,
	"./default/libs/cmaps/Add-H.bcmap": 32735,
	"./default/libs/cmaps/Add-RKSJ-H.bcmap": 3651,
	"./default/libs/cmaps/Add-RKSJ-V.bcmap": 71895,
	"./default/libs/cmaps/Add-V.bcmap": 3685,
	"./default/libs/cmaps/Adobe-CNS1-0.bcmap": 51671,
	"./default/libs/cmaps/Adobe-CNS1-1.bcmap": 27617,
	"./default/libs/cmaps/Adobe-CNS1-2.bcmap": 77552,
	"./default/libs/cmaps/Adobe-CNS1-3.bcmap": 57934,
	"./default/libs/cmaps/Adobe-CNS1-4.bcmap": 19011,
	"./default/libs/cmaps/Adobe-CNS1-5.bcmap": 25109,
	"./default/libs/cmaps/Adobe-CNS1-6.bcmap": 31839,
	"./default/libs/cmaps/Adobe-CNS1-UCS2.bcmap": 14419,
	"./default/libs/cmaps/Adobe-GB1-0.bcmap": 65219,
	"./default/libs/cmaps/Adobe-GB1-1.bcmap": 5524,
	"./default/libs/cmaps/Adobe-GB1-2.bcmap": 5927,
	"./default/libs/cmaps/Adobe-GB1-3.bcmap": 74977,
	"./default/libs/cmaps/Adobe-GB1-4.bcmap": 11672,
	"./default/libs/cmaps/Adobe-GB1-5.bcmap": 94406,
	"./default/libs/cmaps/Adobe-GB1-UCS2.bcmap": 28186,
	"./default/libs/cmaps/Adobe-Japan1-0.bcmap": 65887,
	"./default/libs/cmaps/Adobe-Japan1-1.bcmap": 77454,
	"./default/libs/cmaps/Adobe-Japan1-2.bcmap": 35804,
	"./default/libs/cmaps/Adobe-Japan1-3.bcmap": 66413,
	"./default/libs/cmaps/Adobe-Japan1-4.bcmap": 93467,
	"./default/libs/cmaps/Adobe-Japan1-5.bcmap": 87906,
	"./default/libs/cmaps/Adobe-Japan1-6.bcmap": 21105,
	"./default/libs/cmaps/Adobe-Japan1-UCS2.bcmap": 37430,
	"./default/libs/cmaps/Adobe-Korea1-0.bcmap": 16436,
	"./default/libs/cmaps/Adobe-Korea1-1.bcmap": 81026,
	"./default/libs/cmaps/Adobe-Korea1-2.bcmap": 5387,
	"./default/libs/cmaps/Adobe-Korea1-UCS2.bcmap": 3774,
	"./default/libs/cmaps/B5-H.bcmap": 37239,
	"./default/libs/cmaps/B5-V.bcmap": 96742,
	"./default/libs/cmaps/B5pc-H.bcmap": 29613,
	"./default/libs/cmaps/B5pc-V.bcmap": 73215,
	"./default/libs/cmaps/CNS-EUC-H.bcmap": 46222,
	"./default/libs/cmaps/CNS-EUC-V.bcmap": 68852,
	"./default/libs/cmaps/CNS1-H.bcmap": 32154,
	"./default/libs/cmaps/CNS1-V.bcmap": 96807,
	"./default/libs/cmaps/CNS2-H.bcmap": 70528,
	"./default/libs/cmaps/CNS2-V.bcmap": 5818,
	"./default/libs/cmaps/ETHK-B5-H.bcmap": 38591,
	"./default/libs/cmaps/ETHK-B5-V.bcmap": 9660,
	"./default/libs/cmaps/ETen-B5-H.bcmap": 27149,
	"./default/libs/cmaps/ETen-B5-V.bcmap": 11237,
	"./default/libs/cmaps/ETenms-B5-H.bcmap": 39606,
	"./default/libs/cmaps/ETenms-B5-V.bcmap": 22918,
	"./default/libs/cmaps/EUC-H.bcmap": 50114,
	"./default/libs/cmaps/EUC-V.bcmap": 35861,
	"./default/libs/cmaps/Ext-H.bcmap": 52867,
	"./default/libs/cmaps/Ext-RKSJ-H.bcmap": 16778,
	"./default/libs/cmaps/Ext-RKSJ-V.bcmap": 2849,
	"./default/libs/cmaps/Ext-V.bcmap": 14034,
	"./default/libs/cmaps/GB-EUC-H.bcmap": 86401,
	"./default/libs/cmaps/GB-EUC-V.bcmap": 33700,
	"./default/libs/cmaps/GB-H.bcmap": 94847,
	"./default/libs/cmaps/GB-V.bcmap": 90673,
	"./default/libs/cmaps/GBK-EUC-H.bcmap": 76793,
	"./default/libs/cmaps/GBK-EUC-V.bcmap": 70928,
	"./default/libs/cmaps/GBK2K-H.bcmap": 72472,
	"./default/libs/cmaps/GBK2K-V.bcmap": 56183,
	"./default/libs/cmaps/GBKp-EUC-H.bcmap": 22639,
	"./default/libs/cmaps/GBKp-EUC-V.bcmap": 94988,
	"./default/libs/cmaps/GBT-EUC-H.bcmap": 94568,
	"./default/libs/cmaps/GBT-EUC-V.bcmap": 42532,
	"./default/libs/cmaps/GBT-H.bcmap": 45076,
	"./default/libs/cmaps/GBT-V.bcmap": 12140,
	"./default/libs/cmaps/GBTpc-EUC-H.bcmap": 61679,
	"./default/libs/cmaps/GBTpc-EUC-V.bcmap": 36380,
	"./default/libs/cmaps/GBpc-EUC-H.bcmap": 96585,
	"./default/libs/cmaps/GBpc-EUC-V.bcmap": 39865,
	"./default/libs/cmaps/H.bcmap": 82422,
	"./default/libs/cmaps/HKdla-B5-H.bcmap": 46534,
	"./default/libs/cmaps/HKdla-B5-V.bcmap": 59107,
	"./default/libs/cmaps/HKdlb-B5-H.bcmap": 77290,
	"./default/libs/cmaps/HKdlb-B5-V.bcmap": 88761,
	"./default/libs/cmaps/HKgccs-B5-H.bcmap": 79130,
	"./default/libs/cmaps/HKgccs-B5-V.bcmap": 11087,
	"./default/libs/cmaps/HKm314-B5-H.bcmap": 43095,
	"./default/libs/cmaps/HKm314-B5-V.bcmap": 34962,
	"./default/libs/cmaps/HKm471-B5-H.bcmap": 93391,
	"./default/libs/cmaps/HKm471-B5-V.bcmap": 86789,
	"./default/libs/cmaps/HKscs-B5-H.bcmap": 66978,
	"./default/libs/cmaps/HKscs-B5-V.bcmap": 60809,
	"./default/libs/cmaps/Hankaku.bcmap": 75158,
	"./default/libs/cmaps/Hiragana.bcmap": 12205,
	"./default/libs/cmaps/KSC-EUC-H.bcmap": 80182,
	"./default/libs/cmaps/KSC-EUC-V.bcmap": 65475,
	"./default/libs/cmaps/KSC-H.bcmap": 89150,
	"./default/libs/cmaps/KSC-Johab-H.bcmap": 1308,
	"./default/libs/cmaps/KSC-Johab-V.bcmap": 52233,
	"./default/libs/cmaps/KSC-V.bcmap": 13994,
	"./default/libs/cmaps/KSCms-UHC-H.bcmap": 39019,
	"./default/libs/cmaps/KSCms-UHC-HW-H.bcmap": 16280,
	"./default/libs/cmaps/KSCms-UHC-HW-V.bcmap": 56203,
	"./default/libs/cmaps/KSCms-UHC-V.bcmap": 78587,
	"./default/libs/cmaps/KSCpc-EUC-H.bcmap": 89682,
	"./default/libs/cmaps/KSCpc-EUC-V.bcmap": 26068,
	"./default/libs/cmaps/Katakana.bcmap": 88723,
	"./default/libs/cmaps/LICENSE": 18311,
	"./default/libs/cmaps/NWP-H.bcmap": 17511,
	"./default/libs/cmaps/NWP-V.bcmap": 91231,
	"./default/libs/cmaps/RKSJ-H.bcmap": 64840,
	"./default/libs/cmaps/RKSJ-V.bcmap": 61771,
	"./default/libs/cmaps/Roman.bcmap": 62767,
	"./default/libs/cmaps/UniCNS-UCS2-H.bcmap": 6197,
	"./default/libs/cmaps/UniCNS-UCS2-V.bcmap": 28617,
	"./default/libs/cmaps/UniCNS-UTF16-H.bcmap": 62022,
	"./default/libs/cmaps/UniCNS-UTF16-V.bcmap": 62907,
	"./default/libs/cmaps/UniCNS-UTF32-H.bcmap": 61809,
	"./default/libs/cmaps/UniCNS-UTF32-V.bcmap": 35222,
	"./default/libs/cmaps/UniCNS-UTF8-H.bcmap": 11251,
	"./default/libs/cmaps/UniCNS-UTF8-V.bcmap": 67360,
	"./default/libs/cmaps/UniGB-UCS2-H.bcmap": 88729,
	"./default/libs/cmaps/UniGB-UCS2-V.bcmap": 11565,
	"./default/libs/cmaps/UniGB-UTF16-H.bcmap": 18012,
	"./default/libs/cmaps/UniGB-UTF16-V.bcmap": 50859,
	"./default/libs/cmaps/UniGB-UTF32-H.bcmap": 61746,
	"./default/libs/cmaps/UniGB-UTF32-V.bcmap": 41269,
	"./default/libs/cmaps/UniGB-UTF8-H.bcmap": 90490,
	"./default/libs/cmaps/UniGB-UTF8-V.bcmap": 98365,
	"./default/libs/cmaps/UniJIS-UCS2-H.bcmap": 42029,
	"./default/libs/cmaps/UniJIS-UCS2-HW-H.bcmap": 97806,
	"./default/libs/cmaps/UniJIS-UCS2-HW-V.bcmap": 33966,
	"./default/libs/cmaps/UniJIS-UCS2-V.bcmap": 40339,
	"./default/libs/cmaps/UniJIS-UTF16-H.bcmap": 55511,
	"./default/libs/cmaps/UniJIS-UTF16-V.bcmap": 83131,
	"./default/libs/cmaps/UniJIS-UTF32-H.bcmap": 56694,
	"./default/libs/cmaps/UniJIS-UTF32-V.bcmap": 32800,
	"./default/libs/cmaps/UniJIS-UTF8-H.bcmap": 27867,
	"./default/libs/cmaps/UniJIS-UTF8-V.bcmap": 87280,
	"./default/libs/cmaps/UniJIS2004-UTF16-H.bcmap": 18945,
	"./default/libs/cmaps/UniJIS2004-UTF16-V.bcmap": 95549,
	"./default/libs/cmaps/UniJIS2004-UTF32-H.bcmap": 27143,
	"./default/libs/cmaps/UniJIS2004-UTF32-V.bcmap": 2787,
	"./default/libs/cmaps/UniJIS2004-UTF8-H.bcmap": 42733,
	"./default/libs/cmaps/UniJIS2004-UTF8-V.bcmap": 67312,
	"./default/libs/cmaps/UniJISPro-UCS2-HW-V.bcmap": 67568,
	"./default/libs/cmaps/UniJISPro-UCS2-V.bcmap": 78381,
	"./default/libs/cmaps/UniJISPro-UTF8-V.bcmap": 64090,
	"./default/libs/cmaps/UniJISX0213-UTF32-H.bcmap": 89071,
	"./default/libs/cmaps/UniJISX0213-UTF32-V.bcmap": 92121,
	"./default/libs/cmaps/UniJISX02132004-UTF32-H.bcmap": 69600,
	"./default/libs/cmaps/UniJISX02132004-UTF32-V.bcmap": 46726,
	"./default/libs/cmaps/UniKS-UCS2-H.bcmap": 15501,
	"./default/libs/cmaps/UniKS-UCS2-V.bcmap": 17703,
	"./default/libs/cmaps/UniKS-UTF16-H.bcmap": 14870,
	"./default/libs/cmaps/UniKS-UTF16-V.bcmap": 62275,
	"./default/libs/cmaps/UniKS-UTF32-H.bcmap": 86350,
	"./default/libs/cmaps/UniKS-UTF32-V.bcmap": 97246,
	"./default/libs/cmaps/UniKS-UTF8-H.bcmap": 23387,
	"./default/libs/cmaps/UniKS-UTF8-V.bcmap": 95427,
	"./default/libs/cmaps/V.bcmap": 71553,
	"./default/libs/cmaps/WP-Symbol.bcmap": 62111,
	"./default/loading.gif": 67055,
	"./default/login/arrow-right.png": 99321,
	"./default/login/free_right-tag.png": 11352,
	"./default/login/icon__free-image.png": 16173,
	"./default/login/icon__free-pdf.png": 10508,
	"./default/login/icon__free-realtime.png": 30114,
	"./default/login/icon__free-select.png": 18767,
	"./default/login/icon__free-text.png": 54313,
	"./default/login/icon__free-video.png": 19294,
	"./default/login/icon__free-web.png": 99727,
	"./default/login/icon__left-title.png": 11111,
	"./default/login/icon__summary-focus.png": 68410,
	"./default/login/icon__summary-pdf.png": 53352,
	"./default/login/icon__summary-video.png": 58602,
	"./default/login/icon__summary-web.png": 15454,
	"./default/login/icon__summary.png": 30182,
	"./default/login/icon__translate.png": 29001,
	"./default/login/new_user_banner.png": 53229,
	"./default/login/newuser-banner-bg.png": 28485,
	"./default/login/pro-image.png": 13201,
	"./default/login/pro-pdf.png": 24690,
	"./default/login/pro-realtime.png": 52988,
	"./default/login/pro-right-tag.png": 63867,
	"./default/login/pro-select.png": 84277,
	"./default/login/pro-summary-focus.png": 78348,
	"./default/login/pro-summary-pdf.png": 40643,
	"./default/login/pro-summary-video.png": 65100,
	"./default/login/pro-summary-web.png": 45606,
	"./default/login/pro-video.png": 75361,
	"./default/login/pro-web.png": 38829,
	"./default/login/tag-ai.png": 12132,
	"./default/login/tag-discount5.png": 37902,
	"./default/login/tag-pro.png": 45354,
	"./default/login/tag-read.png": 86733,
	"./default/logo-learning.svg": 54843,
	"./default/logo-purple.png": 45162,
	"./default/logo-select.png": 53808,
	"./default/logo-transparent.png": 84537,
	"./default/logo-white-desc.png": 69807,
	"./default/logo-white.png": 28818,
	"./default/logo-with-border.png": 32472,
	"./default/logo-with-name.png": 83681,
	"./default/online-extension-bg.png": 25974,
	"./default/online-header-logo.png": 10236,
	"./default/online__arrow.png": 56559,
	"./default/online__hands.png": 43699,
	"./default/online__hook.png": 76771,
	"./default/online__line.png": 97077,
	"./default/online__logo.png": 30842,
	"./default/online__pdf-icon.png": 52577,
	"./default/online__pdf.png": 46606,
	"./default/online__pdf_big.png": 44206,
	"./default/online__pdf_big2.png": 8124,
	"./default/online__select-icon.png": 96642,
	"./default/online__select.png": 16050,
	"./default/online__source-lang.png": 97974,
	"./default/online__switch.png": 90161,
	"./default/online__target-lang.png": 77275,
	"./default/online__video-icon.png": 87611,
	"./default/online__video.png": 23634,
	"./default/online__video2.png": 24294,
	"./default/online__video3.png": 97672,
	"./default/online__web-icon.png": 45203,
	"./default/online__web.png": 83181,
	"./default/online__web2.png": 85376,
	"./default/online_arrow-right.png": 47969,
	"./default/online_clear.png": 66737,
	"./default/online_copy.png": 26396,
	"./default/option/icon__close-with-border.png": 55232,
	"./default/option/icon__search.png": 24528,
	"./default/pdf/alltext.png": 63830,
	"./default/pdf/bg__loading.png": 8779,
	"./default/pdf/curve-v1.png": 48914,
	"./default/pdf/curve.png": 99006,
	"./default/pdf/dingdang.png": 58411,
	"./default/pdf/download-pdf-icon-1.png": 46346,
	"./default/pdf/download-pdf-icon-2.png": 56101,
	"./default/pdf/edit.png": 30394,
	"./default/pdf/ext.png": 78147,
	"./default/pdf/hamburger.png": 80526,
	"./default/pdf/hover.png": 13791,
	"./default/pdf/icon__book.png": 8536,
	"./default/pdf/icon__card-link.png": 11199,
	"./default/pdf/icon__extension-bg.png": 752,
	"./default/pdf/icon__history-close.png": 15660,
	"./default/pdf/icon__history-delete.png": 41900,
	"./default/pdf/icon__large-pdf.png": 64211,
	"./default/pdf/icon__loading.png": 94989,
	"./default/pdf/icon__login-left.png": 25322,
	"./default/pdf/icon__notification.png": 84175,
	"./default/pdf/icon__purple-arrow.png": 37788,
	"./default/pdf/icon__puzzle-fragment.png": 68777,
	"./default/pdf/icon__translate.png": 35054,
	"./default/pdf/icon__wx.png": 77671,
	"./default/pdf/icon_focus.png": 35119,
	"./default/pdf/icon_key.png": 10147,
	"./default/pdf/icon_link_pdf.png": 33368,
	"./default/pdf/icon_link_video.png": 10348,
	"./default/pdf/icon_new_collect-full.png": 129,
	"./default/pdf/icon_new_collect.png": 1008,
	"./default/pdf/icon_pdf_answer.png": 71676,
	"./default/pdf/icon_title_pdf.png": 31815,
	"./default/pdf/icon_translation.png": 57394,
	"./default/pdf/image-book.png": 41095,
	"./default/pdf/image-search.png": 36185,
	"./default/pdf/info-icon.png": 4696,
	"./default/pdf/loading-f.png": 95883,
	"./default/pdf/loading-icon-v1.png": 68458,
	"./default/pdf/loading-icon.png": 16315,
	"./default/pdf/mouse-left.png": 83176,
	"./default/pdf/next-page.png": 40289,
	"./default/pdf/paper-icon.png": 21586,
	"./default/pdf/pdf-icon.png": 64594,
	"./default/pdf/pdf-logo.png": 33833,
	"./default/pdf/pdf-upload.png": 17159,
	"./default/pdf/preview-page.png": 68355,
	"./default/pdf/record/icon__pdf-delete.png": 25222,
	"./default/pdf/record/icon__pdf-upload.png": 95650,
	"./default/pdf/rect.png": 61930,
	"./default/pdf/report-icon.png": 5629,
	"./default/pdf/right.png": 54395,
	"./default/pdf/share-icon.png": 367,
	"./default/pdf/share-light.png": 62628,
	"./default/pdf/share-progress.png": 8441,
	"./default/pdf/share-star.png": 34926,
	"./default/pdf/share-underline.png": 89777,
	"./default/pdf/share.png": 56750,
	"./default/pdf/switch-icon.png": 18722,
	"./default/pdf/tip-arrow.png": 71924,
	"./default/pdf/tip1.png": 40152,
	"./default/pdf/tip2-v1.png": 74096,
	"./default/pdf/tip2.png": 96147,
	"./default/pdf/tip3.png": 79029,
	"./default/pdf/tool-history.png": 20150,
	"./default/pdf/tool-upload.png": 70134,
	"./default/pdf/upgrade-bg.png": 98633,
	"./default/pdf/upload-btn-icon.png": 59665,
	"./default/pdf/upload-file.png": 2708,
	"./default/pdf/upload-icon.png": 18033,
	"./default/pdf/upload-rocket.png": 19530,
	"./default/pdf/web.png": 62042,
	"./default/pdf/zoom-in-icon.png": 49022,
	"./default/pdf/zoom-out-icon.png": 48010,
	"./default/pdf_favorite.png": 82122,
	"./default/phone_check.png": 76986,
	"./default/print_icon.png": 71775,
	"./default/share/h5-tips.png": 8263,
	"./default/share/share-qr-code-bg.png": 40939,
	"./default/share/share-qr-code.png": 34975,
	"./default/share/wx-logo.png": 22415,
	"./default/switch-icon.png": 20687,
	"./default/token-bg.png": 17557,
	"./default/uninstall-arrow-icon.png": 21633,
	"./default/uninstall-bg-icon.png": 45667,
	"./default/uninstall-bg-icon2.png": 2121,
	"./default/uninstall-delete-icon.png": 17298,
	"./default/uninstall-line-icon.png": 14528,
	"./default/uninstall-qr-arrow-icon.png": 84535,
	"./default/uninstall-qr-code-icon.png": 23401,
	"./default/uninstall-select-arrow-icon.png": 92009,
	"./default/uninstall-select-down-icon.png": 67684,
	"./default/uninstall-update-bg-icon.png": 44314,
	"./default/uninstall_qr.png": 47861,
	"./default/user/bg__free.png": 13946,
	"./default/user/bg__pro.png": 42471,
	"./default/user/bg__prov.png": 21192,
	"./default/user/icon__edu.png": 56712,
	"./default/user/icon__free-big.png": 95068,
	"./default/user/icon__free-v.png": 6706,
	"./default/user/icon__pro-big.png": 32038,
	"./default/user/icon__pro-v.png": 81197,
	"./default/user/icon__proV-v.png": 28366,
	"./default/user/icon__prov-big.png": 80203,
	"./default/user/icon__record.png": 5748,
	"./default/user/icon__setting.png": 7149,
	"./default/voice.gif": 14588,
	"./default/welcome-arrow-icon.png": 34640,
	"./default/welcome-bg-icon2.png": 96348,
	"./default/welcome-check-icon.png": 944,
	"./default/welcome-number1.png": 78737,
	"./default/welcome-number2.png": 35098,
	"./default/welcome-qrcode-v1.png": 69388,
	"./default/welcome-qrcode.png": 77991,
	"./default/welcome_bg-icon.png": 81014,
	"./default/y-close.png": 49650,
	"./lenovo/arrow-down.png": 36025,
	"./lenovo/banner__fixed-extension.png": 61413,
	"./lenovo/banner__upgrade-bg.png": 31560,
	"./lenovo/banner__vip-intro.png": 74306,
	"./lenovo/bg__brand-h5.png": 30378,
	"./lenovo/bg__brand.png": 73637,
	"./lenovo/bg__fixed-extension-title.png": 20996,
	"./lenovo/bg__huiyi.png": 28326,
	"./lenovo/bg__new-user-discount-bottom-v1.png": 33878,
	"./lenovo/bg__new-user-discount-v1.png": 43739,
	"./lenovo/bg__pdf.png": 62903,
	"./lenovo/bg__upgrade.png": 2087,
	"./lenovo/btn__arrow.png": 89689,
	"./lenovo/buyVipDialog/benefit-icon-1.png": 48702,
	"./lenovo/buyVipDialog/benefit-icon-2.png": 45848,
	"./lenovo/buyVipDialog/benefit-icon-3.png": 9969,
	"./lenovo/buyVipDialog/benefit-icon-4.png": 36817,
	"./lenovo/buyVipDialog/bg__comment-1.png": 89260,
	"./lenovo/buyVipDialog/bg__img.png": 118,
	"./lenovo/buyVipDialog/bg__qr.png": 79767,
	"./lenovo/buyVipDialog/empty-coupon.png": 35413,
	"./lenovo/buyVipDialog/icon__alipay.png": 18194,
	"./lenovo/buyVipDialog/icon__benefit-tab-active.png": 57286,
	"./lenovo/buyVipDialog/icon__benefit-tab-hover.png": 64988,
	"./lenovo/buyVipDialog/icon__benefit-tab.png": 80825,
	"./lenovo/buyVipDialog/icon__buy-record.png": 77242,
	"./lenovo/buyVipDialog/icon__code-disabled.png": 16551,
	"./lenovo/buyVipDialog/icon__code.png": 89967,
	"./lenovo/buyVipDialog/icon__edu-guide.png": 30669,
	"./lenovo/buyVipDialog/icon__first-month.png": 70530,
	"./lenovo/buyVipDialog/icon__func-tab-active.png": 13305,
	"./lenovo/buyVipDialog/icon__func-tab-hover.png": 14073,
	"./lenovo/buyVipDialog/icon__func-tab.png": 42895,
	"./lenovo/buyVipDialog/icon__get.png": 59482,
	"./lenovo/buyVipDialog/icon__limit-welfare.png": 56082,
	"./lenovo/buyVipDialog/icon__plan-active.png": 79627,
	"./lenovo/buyVipDialog/icon__recommended.png": 65162,
	"./lenovo/buyVipDialog/icon__right-arrow.png": 24053,
	"./lenovo/buyVipDialog/icon__right-brown-hover.png": 62347,
	"./lenovo/buyVipDialog/icon__right-brown.png": 54020,
	"./lenovo/buyVipDialog/icon__right-gray-hover.png": 3797,
	"./lenovo/buyVipDialog/icon__right-gray.png": 64897,
	"./lenovo/buyVipDialog/icon__vip-v.png": 93622,
	"./lenovo/buyVipDialog/icon__vip.png": 12407,
	"./lenovo/buyVipDialog/icon__wechat.png": 39054,
	"./lenovo/buyVipDialog/icon__wx-pay.png": 59971,
	"./lenovo/buyVipDialog/pay-success-banner.png": 72004,
	"./lenovo/buyVipDialog/qr-logo-alipay.png": 89163,
	"./lenovo/buyVipDialog/qr-logo-normal.png": 38363,
	"./lenovo/buyVipDialog/right-bg.png": 86279,
	"./lenovo/buyVipDialog/success-black.png": 40014,
	"./lenovo/buyVipDialog/success-purple.png": 57186,
	"./lenovo/buyVipDialog/user-recommend-score.png": 82975,
	"./lenovo/card-close.png": 68238,
	"./lenovo/card-logo.png": 82588,
	"./lenovo/card-setting.png": 65452,
	"./lenovo/card-sound-backup.png": 65468,
	"./lenovo/card-sound.png": 33571,
	"./lenovo/card-voice.gif": 22714,
	"./lenovo/cdn/home-page_icon__logo.png": 95641,
	"./lenovo/cdn/logo-transparent.ico": 33539,
	"./lenovo/cdn/pricing/equity-icon.png": 92118,
	"./lenovo/cdn/translation-icon-v2.png": 61301,
	"./lenovo/clear_number.png": 19040,
	"./lenovo/clear_number_hover.png": 93843,
	"./lenovo/common/icon__btn-arrow.png": 54618,
	"./lenovo/common/icon__copy.svg": 94433,
	"./lenovo/common/icon__download.svg": 52498,
	"./lenovo/common/icon__upload.svg": 4169,
	"./lenovo/common/icon__warning.png": 59708,
	"./lenovo/common/num__1.png": 71443,
	"./lenovo/common/num__2.png": 40626,
	"./lenovo/common/num__3.png": 41866,
	"./lenovo/common/success-gray.png": 59251,
	"./lenovo/contact_icon.png": 79763,
	"./lenovo/download_icon.png": 22107,
	"./lenovo/download_save.png": 72372,
	"./lenovo/edu-user-info.png": 58241,
	"./lenovo/educationIncentives/bell-icon.png": 67422,
	"./lenovo/educationIncentives/bell-star.png": 39845,
	"./lenovo/educationIncentives/bg-line.png": 8993,
	"./lenovo/educationIncentives/big-line.png": 25611,
	"./lenovo/educationIncentives/docs-img.png": 37460,
	"./lenovo/educationIncentives/fireworks.png": 99275,
	"./lenovo/educationIncentives/loading.png": 65999,
	"./lenovo/educationIncentives/price-149.png": 81424,
	"./lenovo/educationIncentives/price-text.png": 59083,
	"./lenovo/educationIncentives/qr-code-bg-icon.png": 13029,
	"./lenovo/educationIncentives/qr-code-bg.png": 8907,
	"./lenovo/educationIncentives/qr-code.png": 20658,
	"./lenovo/educationIncentives/red-star.png": 47479,
	"./lenovo/educationIncentives/short-line.png": 29251,
	"./lenovo/educationIncentives/submit-icon.png": 65621,
	"./lenovo/educationIncentives/title-bg.png": 77718,
	"./lenovo/educationIncentives/world_school_name_list": 21717,
	"./lenovo/educationIncentives/world_school_name_list.json": 21717,
	"./lenovo/educationIncentives/yellow-star-45.png": 21043,
	"./lenovo/educationIncentives/yellow-star.png": 86234,
	"./lenovo/expand-hover.png": 13709,
	"./lenovo/expand.png": 72763,
	"./lenovo/free_tag.png": 13247,
	"./lenovo/home-page-v1/action__ctrl-hover.png": 11042,
	"./lenovo/home-page-v1/banner__edu.png": 8139,
	"./lenovo/home-page-v1/banner__invite.png": 48605,
	"./lenovo/home-page-v1/banner__learning.png": 74736,
	"./lenovo/home-page-v1/bg__banner.png": 26752,
	"./lenovo/home-page-v1/bg__browser-active.png": 12227,
	"./lenovo/home-page-v1/bg__browser-hover.png": 74671,
	"./lenovo/home-page-v1/bg__comment.png": 50746,
	"./lenovo/home-page-v1/bg__guide-1.png": 95380,
	"./lenovo/home-page-v1/bg__guide-2.png": 49628,
	"./lenovo/home-page-v1/bg__install-video-v1.png": 62784,
	"./lenovo/home-page-v1/bg__install-video.png": 19965,
	"./lenovo/home-page-v1/bg__online.png": 42318,
	"./lenovo/home-page-v1/bg__slogan.png": 89115,
	"./lenovo/home-page-v1/bg__title-comment.png": 97755,
	"./lenovo/home-page-v1/bg__title-guide.png": 61713,
	"./lenovo/home-page-v1/bg__top-bg-invite.png": 9780,
	"./lenovo/home-page-v1/bg__top-bg-learning.png": 13664,
	"./lenovo/home-page-v1/bg__top-bg1.png": 15902,
	"./lenovo/home-page-v1/bg__top-bg2.png": 34451,
	"./lenovo/home-page-v1/bg__video-box.png": 20022,
	"./lenovo/home-page-v1/bg__video-hover.png": 61883,
	"./lenovo/home-page-v1/bg__video-pdf.png": 56971,
	"./lenovo/home-page-v1/bg__video-web.png": 2337,
	"./lenovo/home-page-v1/figure.gif": 71178,
	"./lenovo/home-page-v1/icon__close-video-modal-hover.png": 51481,
	"./lenovo/home-page-v1/icon__close-video-modal.png": 79386,
	"./lenovo/home-page-v1/icon__download.png": 11533,
	"./lenovo/home-page-v1/icon__figure-right.png": 13261,
	"./lenovo/home-page-v1/icon__figure-top.png": 24369,
	"./lenovo/home-page-v1/icon__hover.png": 24381,
	"./lenovo/home-page-v1/icon__learning.png": 74318,
	"./lenovo/home-page-v1/icon__online.png": 70950,
	"./lenovo/home-page-v1/icon__pdf.png": 97333,
	"./lenovo/home-page-v1/icon__play.png": 8212,
	"./lenovo/home-page-v1/icon__star.png": 76378,
	"./lenovo/home-page-v1/icon__web.png": 87335,
	"./lenovo/home-page-v1/img__arrow-right.png": 95372,
	"./lenovo/home-page-v1/tips__ctrl-action.png": 24489,
	"./lenovo/home-page-v1/tips__web-click.png": 56278,
	"./lenovo/home-page-v1/yi.png": 1584,
	"./lenovo/hot.gif": 31500,
	"./lenovo/hover-translate-welcome.png": 46530,
	"./lenovo/icon__add.png": 1924,
	"./lenovo/icon__arrow-right-gray-hover.png": 67592,
	"./lenovo/icon__arrow-right-gray.png": 88877,
	"./lenovo/icon__arrow_down.png": 23755,
	"./lenovo/icon__arrow_up.png": 14775,
	"./lenovo/icon__back.png": 63586,
	"./lenovo/icon__bell-gold.png": 80097,
	"./lenovo/icon__bell.png": 76043,
	"./lenovo/icon__card-delete.png": 13472,
	"./lenovo/icon__card-link.png": 40296,
	"./lenovo/icon__card-video.png": 33662,
	"./lenovo/icon__celebrate.png": 97893,
	"./lenovo/icon__checkbox-checked.png": 18584,
	"./lenovo/icon__checkbox-hover.png": 72042,
	"./lenovo/icon__checkbox.png": 56200,
	"./lenovo/icon__close-with-border-hover.png": 20577,
	"./lenovo/icon__close-with-border-v1.png": 5779,
	"./lenovo/icon__close-with-border.png": 37965,
	"./lenovo/icon__close.png": 36372,
	"./lenovo/icon__copy.png": 31431,
	"./lenovo/icon__default-avatar.png": 37674,
	"./lenovo/icon__default-favicon.png": 6585,
	"./lenovo/icon__delete-hover.png": 85896,
	"./lenovo/icon__delete.png": 80311,
	"./lenovo/icon__edit-hover.png": 17062,
	"./lenovo/icon__edit.png": 20758,
	"./lenovo/icon__empty.png": 86320,
	"./lenovo/icon__favorite-empty.png": 66153,
	"./lenovo/icon__key.png": 82231,
	"./lenovo/icon__lang-empty.png": 86689,
	"./lenovo/icon__lingdang.png": 23768,
	"./lenovo/icon__logo.png": 9991,
	"./lenovo/icon__logout-v2.png": 36017,
	"./lenovo/icon__model.png": 66788,
	"./lenovo/icon__original-hover.png": 43306,
	"./lenovo/icon__original.png": 80358,
	"./lenovo/icon__parallel-hover.png": 81945,
	"./lenovo/icon__parallel.png": 14783,
	"./lenovo/icon__pointer.png": 79525,
	"./lenovo/icon__quality-gray.svg": 83099,
	"./lenovo/icon__quality.svg": 18373,
	"./lenovo/icon__question.png": 32173,
	"./lenovo/icon__radio-checked.png": 3674,
	"./lenovo/icon__radio-hover.png": 52900,
	"./lenovo/icon__radio.png": 40087,
	"./lenovo/icon__right-arrow.png": 86889,
	"./lenovo/icon__settings-hover.png": 69332,
	"./lenovo/icon__settings-v1.png": 84728,
	"./lenovo/icon__settings.png": 97413,
	"./lenovo/icon__source-lang.png": 32104,
	"./lenovo/icon__speed-gray.svg": 91998,
	"./lenovo/icon__speed.svg": 68432,
	"./lenovo/icon__star-yellow.png": 50136,
	"./lenovo/icon__star.png": 66507,
	"./lenovo/icon__stick.png": 40822,
	"./lenovo/icon__switch-v1.png": 8534,
	"./lenovo/icon__switch.png": 19837,
	"./lenovo/icon__tab-favorite-empty.png": 53362,
	"./lenovo/icon__tab-favorite.png": 33551,
	"./lenovo/icon__tab-pdf-empty.png": 92028,
	"./lenovo/icon__tab-pdf.png": 87830,
	"./lenovo/icon__target-lang.png": 69231,
	"./lenovo/icon__top-img-v1.png": 54624,
	"./lenovo/icon__translate-complete.png": 56565,
	"./lenovo/icon__translation-hover.png": 58832,
	"./lenovo/icon__translation.png": 12397,
	"./lenovo/icon__vip-free.png": 19691,
	"./lenovo/icon__vip-vip1.png": 28516,
	"./lenovo/icon__yi.png": 11550,
	"./lenovo/icon_discount.png": 37777,
	"./lenovo/icon_login.png": 185,
	"./lenovo/icon_logout.png": 86853,
	"./lenovo/icon_orders.png": 21468,
	"./lenovo/icon_setting.png": 25905,
	"./lenovo/icon_welcome.png": 90104,
	"./lenovo/image-banner-welcome.png": 95737,
	"./lenovo/image-icon-welcome.png": 13707,
	"./lenovo/image-translate/icon__image.svg": 13700,
	"./lenovo/image-translate/icon__reload.svg": 40324,
	"./lenovo/image-translate/icon__upload-img.svg": 44574,
	"./lenovo/install-arrow-top-icon.png": 42320,
	"./lenovo/install-bell-icon.png": 19014,
	"./lenovo/install-store-icon.png": 94852,
	"./lenovo/language-switch.png": 25290,
	"./lenovo/learn-icon-welcome.png": 30448,
	"./lenovo/learn-welcome.png": 21542,
	"./lenovo/learned_count_bg.png": 32081,
	"./lenovo/learned_count_bg_backup.png": 900,
	"./lenovo/learned_count_icon.png": 57609,
	"./lenovo/learned_count_icon_backup.png": 20291,
	"./lenovo/learning/empty__grasp.png": 5212,
	"./lenovo/learning/empty__unlearned.png": 11206,
	"./lenovo/learning/icon__add-grasp-v1.png": 18153,
	"./lenovo/learning/icon__add-unlearned-v1-backup.png": 97673,
	"./lenovo/learning/icon__add-unlearned-v1.png": 40376,
	"./lenovo/learning/icon__arrow.png": 79859,
	"./lenovo/learning/icon__back.png": 39457,
	"./lenovo/learning/icon__delete.png": 97362,
	"./lenovo/learning/icon__in-grasp.png": 933,
	"./lenovo/learning/icon__in-unlearned.png": 99553,
	"./lenovo/learning/icon__pro-lock.png": 94070,
	"./lenovo/learning/icon__pro-v-lock.png": 24798,
	"./lenovo/learning/icon__qingzhu.png": 18523,
	"./lenovo/learning/icon__star.png": 92277,
	"./lenovo/learning/like.png": 82297,
	"./lenovo/learning/path__empty-line.png": 80413,
	"./lenovo/learning/path__line-1.png": 95930,
	"./lenovo/learning/path__line.png": 65086,
	"./lenovo/learning/编组 14备份 3@2x.png": 62730,
	"./lenovo/libs/cmaps/78-EUC-H.bcmap": 36645,
	"./lenovo/libs/cmaps/78-EUC-V.bcmap": 60905,
	"./lenovo/libs/cmaps/78-H.bcmap": 89365,
	"./lenovo/libs/cmaps/78-RKSJ-H.bcmap": 81637,
	"./lenovo/libs/cmaps/78-RKSJ-V.bcmap": 81553,
	"./lenovo/libs/cmaps/78-V.bcmap": 62998,
	"./lenovo/libs/cmaps/78ms-RKSJ-H.bcmap": 75000,
	"./lenovo/libs/cmaps/78ms-RKSJ-V.bcmap": 51861,
	"./lenovo/libs/cmaps/83pv-RKSJ-H.bcmap": 16728,
	"./lenovo/libs/cmaps/90ms-RKSJ-H.bcmap": 70781,
	"./lenovo/libs/cmaps/90ms-RKSJ-V.bcmap": 76284,
	"./lenovo/libs/cmaps/90msp-RKSJ-H.bcmap": 3335,
	"./lenovo/libs/cmaps/90msp-RKSJ-V.bcmap": 9285,
	"./lenovo/libs/cmaps/90pv-RKSJ-H.bcmap": 25919,
	"./lenovo/libs/cmaps/90pv-RKSJ-V.bcmap": 87204,
	"./lenovo/libs/cmaps/Add-H.bcmap": 1484,
	"./lenovo/libs/cmaps/Add-RKSJ-H.bcmap": 39261,
	"./lenovo/libs/cmaps/Add-RKSJ-V.bcmap": 5557,
	"./lenovo/libs/cmaps/Add-V.bcmap": 86416,
	"./lenovo/libs/cmaps/Adobe-CNS1-0.bcmap": 80057,
	"./lenovo/libs/cmaps/Adobe-CNS1-1.bcmap": 48573,
	"./lenovo/libs/cmaps/Adobe-CNS1-2.bcmap": 42836,
	"./lenovo/libs/cmaps/Adobe-CNS1-3.bcmap": 92929,
	"./lenovo/libs/cmaps/Adobe-CNS1-4.bcmap": 63784,
	"./lenovo/libs/cmaps/Adobe-CNS1-5.bcmap": 94627,
	"./lenovo/libs/cmaps/Adobe-CNS1-6.bcmap": 33300,
	"./lenovo/libs/cmaps/Adobe-CNS1-UCS2.bcmap": 26419,
	"./lenovo/libs/cmaps/Adobe-GB1-0.bcmap": 90105,
	"./lenovo/libs/cmaps/Adobe-GB1-1.bcmap": 11288,
	"./lenovo/libs/cmaps/Adobe-GB1-2.bcmap": 71720,
	"./lenovo/libs/cmaps/Adobe-GB1-3.bcmap": 78041,
	"./lenovo/libs/cmaps/Adobe-GB1-4.bcmap": 89113,
	"./lenovo/libs/cmaps/Adobe-GB1-5.bcmap": 59266,
	"./lenovo/libs/cmaps/Adobe-GB1-UCS2.bcmap": 26136,
	"./lenovo/libs/cmaps/Adobe-Japan1-0.bcmap": 62830,
	"./lenovo/libs/cmaps/Adobe-Japan1-1.bcmap": 58125,
	"./lenovo/libs/cmaps/Adobe-Japan1-2.bcmap": 93590,
	"./lenovo/libs/cmaps/Adobe-Japan1-3.bcmap": 91617,
	"./lenovo/libs/cmaps/Adobe-Japan1-4.bcmap": 25392,
	"./lenovo/libs/cmaps/Adobe-Japan1-5.bcmap": 90184,
	"./lenovo/libs/cmaps/Adobe-Japan1-6.bcmap": 87606,
	"./lenovo/libs/cmaps/Adobe-Japan1-UCS2.bcmap": 14676,
	"./lenovo/libs/cmaps/Adobe-Korea1-0.bcmap": 72752,
	"./lenovo/libs/cmaps/Adobe-Korea1-1.bcmap": 4376,
	"./lenovo/libs/cmaps/Adobe-Korea1-2.bcmap": 92819,
	"./lenovo/libs/cmaps/Adobe-Korea1-UCS2.bcmap": 11018,
	"./lenovo/libs/cmaps/B5-H.bcmap": 22421,
	"./lenovo/libs/cmaps/B5-V.bcmap": 41321,
	"./lenovo/libs/cmaps/B5pc-H.bcmap": 18749,
	"./lenovo/libs/cmaps/B5pc-V.bcmap": 52550,
	"./lenovo/libs/cmaps/CNS-EUC-H.bcmap": 5650,
	"./lenovo/libs/cmaps/CNS-EUC-V.bcmap": 62134,
	"./lenovo/libs/cmaps/CNS1-H.bcmap": 65271,
	"./lenovo/libs/cmaps/CNS1-V.bcmap": 29286,
	"./lenovo/libs/cmaps/CNS2-H.bcmap": 2057,
	"./lenovo/libs/cmaps/CNS2-V.bcmap": 15505,
	"./lenovo/libs/cmaps/ETHK-B5-H.bcmap": 412,
	"./lenovo/libs/cmaps/ETHK-B5-V.bcmap": 9906,
	"./lenovo/libs/cmaps/ETen-B5-H.bcmap": 67883,
	"./lenovo/libs/cmaps/ETen-B5-V.bcmap": 86082,
	"./lenovo/libs/cmaps/ETenms-B5-H.bcmap": 10477,
	"./lenovo/libs/cmaps/ETenms-B5-V.bcmap": 88471,
	"./lenovo/libs/cmaps/EUC-H.bcmap": 34149,
	"./lenovo/libs/cmaps/EUC-V.bcmap": 65077,
	"./lenovo/libs/cmaps/Ext-H.bcmap": 7773,
	"./lenovo/libs/cmaps/Ext-RKSJ-H.bcmap": 34538,
	"./lenovo/libs/cmaps/Ext-RKSJ-V.bcmap": 25778,
	"./lenovo/libs/cmaps/Ext-V.bcmap": 41488,
	"./lenovo/libs/cmaps/GB-EUC-H.bcmap": 57747,
	"./lenovo/libs/cmaps/GB-EUC-V.bcmap": 60550,
	"./lenovo/libs/cmaps/GB-H.bcmap": 44816,
	"./lenovo/libs/cmaps/GB-V.bcmap": 3782,
	"./lenovo/libs/cmaps/GBK-EUC-H.bcmap": 85299,
	"./lenovo/libs/cmaps/GBK-EUC-V.bcmap": 49676,
	"./lenovo/libs/cmaps/GBK2K-H.bcmap": 26731,
	"./lenovo/libs/cmaps/GBK2K-V.bcmap": 59866,
	"./lenovo/libs/cmaps/GBKp-EUC-H.bcmap": 83157,
	"./lenovo/libs/cmaps/GBKp-EUC-V.bcmap": 19167,
	"./lenovo/libs/cmaps/GBT-EUC-H.bcmap": 76604,
	"./lenovo/libs/cmaps/GBT-EUC-V.bcmap": 24233,
	"./lenovo/libs/cmaps/GBT-H.bcmap": 83415,
	"./lenovo/libs/cmaps/GBT-V.bcmap": 93224,
	"./lenovo/libs/cmaps/GBTpc-EUC-H.bcmap": 42818,
	"./lenovo/libs/cmaps/GBTpc-EUC-V.bcmap": 30828,
	"./lenovo/libs/cmaps/GBpc-EUC-H.bcmap": 4855,
	"./lenovo/libs/cmaps/GBpc-EUC-V.bcmap": 70953,
	"./lenovo/libs/cmaps/H.bcmap": 15279,
	"./lenovo/libs/cmaps/HKdla-B5-H.bcmap": 40860,
	"./lenovo/libs/cmaps/HKdla-B5-V.bcmap": 85350,
	"./lenovo/libs/cmaps/HKdlb-B5-H.bcmap": 59017,
	"./lenovo/libs/cmaps/HKdlb-B5-V.bcmap": 23527,
	"./lenovo/libs/cmaps/HKgccs-B5-H.bcmap": 93276,
	"./lenovo/libs/cmaps/HKgccs-B5-V.bcmap": 81628,
	"./lenovo/libs/cmaps/HKm314-B5-H.bcmap": 89992,
	"./lenovo/libs/cmaps/HKm314-B5-V.bcmap": 943,
	"./lenovo/libs/cmaps/HKm471-B5-H.bcmap": 36239,
	"./lenovo/libs/cmaps/HKm471-B5-V.bcmap": 35546,
	"./lenovo/libs/cmaps/HKscs-B5-H.bcmap": 7885,
	"./lenovo/libs/cmaps/HKscs-B5-V.bcmap": 2134,
	"./lenovo/libs/cmaps/Hankaku.bcmap": 71961,
	"./lenovo/libs/cmaps/Hiragana.bcmap": 28833,
	"./lenovo/libs/cmaps/KSC-EUC-H.bcmap": 99597,
	"./lenovo/libs/cmaps/KSC-EUC-V.bcmap": 57400,
	"./lenovo/libs/cmaps/KSC-H.bcmap": 93235,
	"./lenovo/libs/cmaps/KSC-Johab-H.bcmap": 81125,
	"./lenovo/libs/cmaps/KSC-Johab-V.bcmap": 27317,
	"./lenovo/libs/cmaps/KSC-V.bcmap": 30651,
	"./lenovo/libs/cmaps/KSCms-UHC-H.bcmap": 26128,
	"./lenovo/libs/cmaps/KSCms-UHC-HW-H.bcmap": 90998,
	"./lenovo/libs/cmaps/KSCms-UHC-HW-V.bcmap": 81974,
	"./lenovo/libs/cmaps/KSCms-UHC-V.bcmap": 96510,
	"./lenovo/libs/cmaps/KSCpc-EUC-H.bcmap": 63632,
	"./lenovo/libs/cmaps/KSCpc-EUC-V.bcmap": 95513,
	"./lenovo/libs/cmaps/Katakana.bcmap": 70281,
	"./lenovo/libs/cmaps/LICENSE": 88359,
	"./lenovo/libs/cmaps/NWP-H.bcmap": 92961,
	"./lenovo/libs/cmaps/NWP-V.bcmap": 5146,
	"./lenovo/libs/cmaps/RKSJ-H.bcmap": 72449,
	"./lenovo/libs/cmaps/RKSJ-V.bcmap": 35353,
	"./lenovo/libs/cmaps/Roman.bcmap": 45565,
	"./lenovo/libs/cmaps/UniCNS-UCS2-H.bcmap": 1808,
	"./lenovo/libs/cmaps/UniCNS-UCS2-V.bcmap": 8781,
	"./lenovo/libs/cmaps/UniCNS-UTF16-H.bcmap": 78428,
	"./lenovo/libs/cmaps/UniCNS-UTF16-V.bcmap": 6595,
	"./lenovo/libs/cmaps/UniCNS-UTF32-H.bcmap": 76169,
	"./lenovo/libs/cmaps/UniCNS-UTF32-V.bcmap": 97386,
	"./lenovo/libs/cmaps/UniCNS-UTF8-H.bcmap": 83820,
	"./lenovo/libs/cmaps/UniCNS-UTF8-V.bcmap": 87591,
	"./lenovo/libs/cmaps/UniGB-UCS2-H.bcmap": 58945,
	"./lenovo/libs/cmaps/UniGB-UCS2-V.bcmap": 42353,
	"./lenovo/libs/cmaps/UniGB-UTF16-H.bcmap": 89367,
	"./lenovo/libs/cmaps/UniGB-UTF16-V.bcmap": 8346,
	"./lenovo/libs/cmaps/UniGB-UTF32-H.bcmap": 24614,
	"./lenovo/libs/cmaps/UniGB-UTF32-V.bcmap": 3056,
	"./lenovo/libs/cmaps/UniGB-UTF8-H.bcmap": 52323,
	"./lenovo/libs/cmaps/UniGB-UTF8-V.bcmap": 2941,
	"./lenovo/libs/cmaps/UniJIS-UCS2-H.bcmap": 30663,
	"./lenovo/libs/cmaps/UniJIS-UCS2-HW-H.bcmap": 59967,
	"./lenovo/libs/cmaps/UniJIS-UCS2-HW-V.bcmap": 44181,
	"./lenovo/libs/cmaps/UniJIS-UCS2-V.bcmap": 83902,
	"./lenovo/libs/cmaps/UniJIS-UTF16-H.bcmap": 17966,
	"./lenovo/libs/cmaps/UniJIS-UTF16-V.bcmap": 81484,
	"./lenovo/libs/cmaps/UniJIS-UTF32-H.bcmap": 28523,
	"./lenovo/libs/cmaps/UniJIS-UTF32-V.bcmap": 54681,
	"./lenovo/libs/cmaps/UniJIS-UTF8-H.bcmap": 21607,
	"./lenovo/libs/cmaps/UniJIS-UTF8-V.bcmap": 46170,
	"./lenovo/libs/cmaps/UniJIS2004-UTF16-H.bcmap": 46392,
	"./lenovo/libs/cmaps/UniJIS2004-UTF16-V.bcmap": 45213,
	"./lenovo/libs/cmaps/UniJIS2004-UTF32-H.bcmap": 8171,
	"./lenovo/libs/cmaps/UniJIS2004-UTF32-V.bcmap": 97124,
	"./lenovo/libs/cmaps/UniJIS2004-UTF8-H.bcmap": 43487,
	"./lenovo/libs/cmaps/UniJIS2004-UTF8-V.bcmap": 1693,
	"./lenovo/libs/cmaps/UniJISPro-UCS2-HW-V.bcmap": 24702,
	"./lenovo/libs/cmaps/UniJISPro-UCS2-V.bcmap": 70422,
	"./lenovo/libs/cmaps/UniJISPro-UTF8-V.bcmap": 60955,
	"./lenovo/libs/cmaps/UniJISX0213-UTF32-H.bcmap": 96141,
	"./lenovo/libs/cmaps/UniJISX0213-UTF32-V.bcmap": 45949,
	"./lenovo/libs/cmaps/UniJISX02132004-UTF32-H.bcmap": 19307,
	"./lenovo/libs/cmaps/UniJISX02132004-UTF32-V.bcmap": 20885,
	"./lenovo/libs/cmaps/UniKS-UCS2-H.bcmap": 14388,
	"./lenovo/libs/cmaps/UniKS-UCS2-V.bcmap": 64013,
	"./lenovo/libs/cmaps/UniKS-UTF16-H.bcmap": 31715,
	"./lenovo/libs/cmaps/UniKS-UTF16-V.bcmap": 30338,
	"./lenovo/libs/cmaps/UniKS-UTF32-H.bcmap": 67960,
	"./lenovo/libs/cmaps/UniKS-UTF32-V.bcmap": 50679,
	"./lenovo/libs/cmaps/UniKS-UTF8-H.bcmap": 48192,
	"./lenovo/libs/cmaps/UniKS-UTF8-V.bcmap": 74731,
	"./lenovo/libs/cmaps/V.bcmap": 26919,
	"./lenovo/libs/cmaps/WP-Symbol.bcmap": 76580,
	"./lenovo/line-global_rightArrow-hover.png": 9101,
	"./lenovo/loading.gif": 68463,
	"./lenovo/login/arrow-right.png": 39891,
	"./lenovo/login/free_right-tag.png": 44127,
	"./lenovo/login/icon__free-image.png": 9456,
	"./lenovo/login/icon__free-pdf.png": 53366,
	"./lenovo/login/icon__free-realtime.png": 44713,
	"./lenovo/login/icon__free-select.png": 67924,
	"./lenovo/login/icon__free-text.png": 34945,
	"./lenovo/login/icon__free-video.png": 33141,
	"./lenovo/login/icon__free-web.png": 92187,
	"./lenovo/login/icon__left-title.png": 73266,
	"./lenovo/login/icon__summary-focus.png": 15756,
	"./lenovo/login/icon__summary-pdf.png": 99486,
	"./lenovo/login/icon__summary-video.png": 82323,
	"./lenovo/login/icon__summary-web.png": 31094,
	"./lenovo/login/icon__summary.png": 38043,
	"./lenovo/login/icon__translate.png": 78730,
	"./lenovo/login/new_user_banner.png": 86097,
	"./lenovo/login/newuser-banner-bg.png": 36234,
	"./lenovo/login/pro-image.png": 65971,
	"./lenovo/login/pro-pdf.png": 57436,
	"./lenovo/login/pro-realtime.png": 6856,
	"./lenovo/login/pro-right-tag.png": 38143,
	"./lenovo/login/pro-select.png": 60794,
	"./lenovo/login/pro-summary-focus.png": 59734,
	"./lenovo/login/pro-summary-pdf.png": 98244,
	"./lenovo/login/pro-summary-video.png": 19000,
	"./lenovo/login/pro-summary-web.png": 73227,
	"./lenovo/login/pro-video.png": 96725,
	"./lenovo/login/pro-web.png": 10587,
	"./lenovo/login/tag-ai.png": 67007,
	"./lenovo/login/tag-discount5.png": 27357,
	"./lenovo/login/tag-pro.png": 18560,
	"./lenovo/login/tag-read.png": 72114,
	"./lenovo/logo-learning.svg": 19259,
	"./lenovo/logo-purple.png": 19723,
	"./lenovo/logo-select.png": 60673,
	"./lenovo/logo-transparent.png": 41181,
	"./lenovo/logo-white-desc.png": 66619,
	"./lenovo/logo-white.png": 73417,
	"./lenovo/logo-with-border.png": 56854,
	"./lenovo/logo-with-name.png": 976,
	"./lenovo/manage_arrow.png": 81845,
	"./lenovo/manage_icon1.png": 54639,
	"./lenovo/manage_icon2.png": 17806,
	"./lenovo/mode_book-active.png": 36531,
	"./lenovo/mode_book.png": 22138,
	"./lenovo/mode_learn-active.png": 96043,
	"./lenovo/mode_learn.png": 4426,
	"./lenovo/new_max_header_bg.png": 54787,
	"./lenovo/new_max_qr_border.png": 51537,
	"./lenovo/new_ultra_header_bg.png": 36352,
	"./lenovo/new_ultra_qr_border.png": 14832,
	"./lenovo/online-extension-bg.png": 85293,
	"./lenovo/online-header-logo.png": 94151,
	"./lenovo/online__arrow.png": 46391,
	"./lenovo/online__hands.png": 72290,
	"./lenovo/online__hook.png": 32520,
	"./lenovo/online__line.png": 21525,
	"./lenovo/online__logo.png": 15961,
	"./lenovo/online__pdf-icon.png": 86344,
	"./lenovo/online__pdf.png": 82235,
	"./lenovo/online__pdf_big.png": 59059,
	"./lenovo/online__pdf_big2.png": 31120,
	"./lenovo/online__select-icon.png": 53909,
	"./lenovo/online__select.png": 55459,
	"./lenovo/online__source-lang.png": 47667,
	"./lenovo/online__switch.png": 16791,
	"./lenovo/online__target-lang.png": 98488,
	"./lenovo/online__video-icon.png": 29173,
	"./lenovo/online__video.png": 37087,
	"./lenovo/online__video2.png": 61826,
	"./lenovo/online__video3.png": 96556,
	"./lenovo/online__web-icon.png": 11142,
	"./lenovo/online__web.png": 19499,
	"./lenovo/online__web2.png": 13431,
	"./lenovo/online_arrow-right.png": 68849,
	"./lenovo/online_clear.png": 22361,
	"./lenovo/online_copy.png": 59132,
	"./lenovo/option/icon__close-with-border.png": 57458,
	"./lenovo/option/icon__search.png": 3591,
	"./lenovo/pdf/alltext.png": 95412,
	"./lenovo/pdf/bg__loading.png": 83909,
	"./lenovo/pdf/curve-v1.png": 91832,
	"./lenovo/pdf/curve.png": 68628,
	"./lenovo/pdf/dingdang.png": 55122,
	"./lenovo/pdf/download-pdf-icon-1.png": 5856,
	"./lenovo/pdf/download-pdf-icon-2.png": 93726,
	"./lenovo/pdf/edit.png": 79863,
	"./lenovo/pdf/ext.png": 89419,
	"./lenovo/pdf/hamburger.png": 52430,
	"./lenovo/pdf/hover.png": 29365,
	"./lenovo/pdf/icon__book.png": 81558,
	"./lenovo/pdf/icon__card-link.png": 23317,
	"./lenovo/pdf/icon__extension-bg.png": 50163,
	"./lenovo/pdf/icon__history-close.png": 35048,
	"./lenovo/pdf/icon__history-delete.png": 1903,
	"./lenovo/pdf/icon__large-pdf.png": 14020,
	"./lenovo/pdf/icon__loading.png": 36690,
	"./lenovo/pdf/icon__login-left.png": 58901,
	"./lenovo/pdf/icon__notification.png": 96648,
	"./lenovo/pdf/icon__purple-arrow.png": 26355,
	"./lenovo/pdf/icon__puzzle-fragment.png": 32172,
	"./lenovo/pdf/icon__translate.png": 45730,
	"./lenovo/pdf/icon__wx.png": 20375,
	"./lenovo/pdf/icon_focus.png": 15214,
	"./lenovo/pdf/icon_key.png": 62368,
	"./lenovo/pdf/icon_link_pdf.png": 21452,
	"./lenovo/pdf/icon_link_video.png": 23987,
	"./lenovo/pdf/icon_new_collect-full.png": 49877,
	"./lenovo/pdf/icon_new_collect.png": 50166,
	"./lenovo/pdf/icon_pdf_answer.png": 25593,
	"./lenovo/pdf/icon_title_pdf.png": 70737,
	"./lenovo/pdf/icon_translation.png": 89258,
	"./lenovo/pdf/image-book.png": 8541,
	"./lenovo/pdf/image-search.png": 49946,
	"./lenovo/pdf/info-icon.png": 56561,
	"./lenovo/pdf/loading-f.png": 92985,
	"./lenovo/pdf/loading-icon-v1.png": 24848,
	"./lenovo/pdf/loading-icon.png": 26714,
	"./lenovo/pdf/mouse-left.png": 61846,
	"./lenovo/pdf/next-page.png": 51137,
	"./lenovo/pdf/paper-icon.png": 7481,
	"./lenovo/pdf/pdf-icon.png": 40775,
	"./lenovo/pdf/pdf-logo.png": 2590,
	"./lenovo/pdf/pdf-upload.png": 30523,
	"./lenovo/pdf/preview-page.png": 44510,
	"./lenovo/pdf/record/icon__pdf-delete.png": 44729,
	"./lenovo/pdf/record/icon__pdf-upload.png": 25536,
	"./lenovo/pdf/rect.png": 82946,
	"./lenovo/pdf/report-icon.png": 63526,
	"./lenovo/pdf/right.png": 59907,
	"./lenovo/pdf/share-icon.png": 24533,
	"./lenovo/pdf/share-light.png": 72060,
	"./lenovo/pdf/share-progress.png": 5616,
	"./lenovo/pdf/share-star.png": 7917,
	"./lenovo/pdf/share-underline.png": 96899,
	"./lenovo/pdf/share.png": 4430,
	"./lenovo/pdf/switch-icon.png": 53379,
	"./lenovo/pdf/tip-arrow.png": 87850,
	"./lenovo/pdf/tip1.png": 15264,
	"./lenovo/pdf/tip2-v1.png": 80721,
	"./lenovo/pdf/tip2.png": 19909,
	"./lenovo/pdf/tip3.png": 88944,
	"./lenovo/pdf/tool-history.png": 81479,
	"./lenovo/pdf/tool-upload.png": 59801,
	"./lenovo/pdf/upgrade-bg.png": 34623,
	"./lenovo/pdf/upload-btn-icon.png": 65511,
	"./lenovo/pdf/upload-file.png": 54098,
	"./lenovo/pdf/upload-icon.png": 89126,
	"./lenovo/pdf/upload-rocket.png": 54286,
	"./lenovo/pdf/web.png": 45350,
	"./lenovo/pdf/zoom-in-icon.png": 75538,
	"./lenovo/pdf/zoom-out-icon.png": 27510,
	"./lenovo/pdf_back.png": 74787,
	"./lenovo/pdf_btn_arrow.png": 25441,
	"./lenovo/pdf_favorite.png": 24873,
	"./lenovo/pdf_icon.png": 91715,
	"./lenovo/pdf_page.png": 39743,
	"./lenovo/phone_check.png": 9512,
	"./lenovo/price-desc-item-arrow.png": 69579,
	"./lenovo/price_free.png": 13733,
	"./lenovo/price_max.png": 99422,
	"./lenovo/price_ultra.png": 29839,
	"./lenovo/print_icon.png": 71253,
	"./lenovo/search-banner-welcome.png": 11534,
	"./lenovo/search-icon-welcome.png": 40953,
	"./lenovo/selection-arrow.png": 4247,
	"./lenovo/selection-trans-welcome.png": 55762,
	"./lenovo/share/h5-tips.png": 17200,
	"./lenovo/share/share-qr-code-bg.png": 88432,
	"./lenovo/share/share-qr-code.png": 43760,
	"./lenovo/share/wx-logo.png": 74275,
	"./lenovo/success-green.png": 26042,
	"./lenovo/switch-icon.png": 21226,
	"./lenovo/token-bg.png": 89297,
	"./lenovo/translate_cur_page.png": 41226,
	"./lenovo/translate_switch.png": 34468,
	"./lenovo/uninstall-arrow-icon.png": 23517,
	"./lenovo/uninstall-bg-icon.png": 7144,
	"./lenovo/uninstall-bg-icon2.png": 94559,
	"./lenovo/uninstall-delete-icon.png": 21859,
	"./lenovo/uninstall-line-icon.png": 73667,
	"./lenovo/uninstall-qr-arrow-icon.png": 96051,
	"./lenovo/uninstall-qr-code-icon.png": 75548,
	"./lenovo/uninstall-select-arrow-icon.png": 56321,
	"./lenovo/uninstall-select-down-icon.png": 77332,
	"./lenovo/uninstall-update-bg-icon.png": 19100,
	"./lenovo/unknown_count_bg.png": 15962,
	"./lenovo/unknown_count_bg_backup.png": 54872,
	"./lenovo/unknown_count_icon.png": 75079,
	"./lenovo/unknown_count_icon_backup.png": 85330,
	"./lenovo/upgradeBox/bg__1.png": 45258,
	"./lenovo/upgradeBox/bg__2.png": 60797,
	"./lenovo/upgradeBox/bg__3.png": 2233,
	"./lenovo/upgrade_alert_arrow.png": 55337,
	"./lenovo/upgrade_alert_arrow_hover.png": 19058,
	"./lenovo/upgrade_alert_func.png": 95920,
	"./lenovo/upgrade_alert_price.png": 44371,
	"./lenovo/upgrade_alert_top.png": 55306,
	"./lenovo/user-info-bg.png": 45088,
	"./lenovo/user/bg__free.png": 71918,
	"./lenovo/user/bg__pro.png": 29993,
	"./lenovo/user/bg__prov.png": 64103,
	"./lenovo/user/icon__edu.png": 24901,
	"./lenovo/user/icon__free-big.png": 43698,
	"./lenovo/user/icon__free-v.png": 46501,
	"./lenovo/user/icon__pro-big.png": 65383,
	"./lenovo/user/icon__pro-v.png": 11172,
	"./lenovo/user/icon__proV-v.png": 89950,
	"./lenovo/user/icon__prov-big.png": 18994,
	"./lenovo/user/icon__record.png": 13765,
	"./lenovo/user/icon__setting.png": 53122,
	"./lenovo/video-icon-welcome.png": 57494,
	"./lenovo/video-trans-welcome.png": 33710,
	"./lenovo/vip-tag.png": 5450,
	"./lenovo/voice.gif": 95126,
	"./lenovo/web_translate_welcome.png": 72228,
	"./lenovo/welcome-arrow-icon.png": 5293,
	"./lenovo/welcome-arrow-icon_backup.png": 17681,
	"./lenovo/welcome-bg-icon2.png": 76838,
	"./lenovo/welcome-check-icon.png": 76442,
	"./lenovo/welcome-number1.png": 24644,
	"./lenovo/welcome-number2.png": 51904,
	"./lenovo/welcome-qrcode-v1.png": 45840,
	"./lenovo/welcome-qrcode.png": 75275,
	"./lenovo/welcome_bg-icon.png": 63031,
	"./lenovo/white-arrow.png": 90197,
	"./lenovo/words-empty.png": 25908,
	"./lenovo/y-close.png": 75385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;